import defaultLocales from 'globals/locales/default';

const getLocale = (key: string): string => {
  switch (key) {
    case 'welcome':
      return defaultLocales.welcome;
    case 'dashboard':
      return defaultLocales.dashboard;
    case 'reports':
      return defaultLocales.reports;
    case 'invitations':
      return defaultLocales.invitations;
    case 'developers':
      return defaultLocales.developers;
    case 'settings':
      return defaultLocales.settings;
    case 'billings':
      return defaultLocales.billings;
    case 'invite-customer':
      return defaultLocales.inviteCustomer;
    case 'profile-settings':
      return defaultLocales.profileSettings;
    case 'report':
      return defaultLocales.report;
    case 'leaderboard':
      return defaultLocales.leaderboard;
    default:
      return defaultLocales.dashboard;
  }
};

export const getTitle = (pathname: string): string => {
  const key = pathname.replace(/^\//, '').split('/')[0];
  return getLocale(key);
};
